"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { AlertCircle } from "lucide-react";
function QuoteGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="32381" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="aspect-[3/4] w-full animate-pulse rounded-none bg-muted/20" />)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[400px] flex-col items-center justify-center text-center">
        <AlertCircle className="mb-4 size-10 text-destructive" />
        <p className="text-muted-foreground mb-4">
          Unable to load project data.
        </p>
        <button onClick={refetch} className="text-primary hover:text-primary/80 underline underline-offset-4">
          Try again
        </button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex min-h-[400px] items-center justify-center text-center">
        <p className="text-muted-foreground">No impact metrics found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group relative block h-full w-full overflow-hidden rounded-none border border-border/50 bg-card shadow-[0_20px_40px_rgba(0,0,0,0.05)] transition-all duration-500 hover:scale-105 hover:border-l-4 hover:border-l-ring" data-index={i}>
          {}
          <div className="absolute inset-0 h-full w-full bg-muted">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover opacity-40 transition-transform duration-700 will-change-transform group-hover:scale-110" /> : <div className="flex h-full w-full items-center justify-center bg-secondary/10 text-ring/20">
                <span className="font-sans text-4xl font-bold italic">KPI</span>
              </div>}
          </div>

          {}
          <div className="absolute bottom-0 left-0 right-0 border-t border-border/10 bg-card/95 p-8 backdrop-blur-md transition-colors duration-300 group-hover:bg-card">
            <div className="flex flex-col gap-4">
              {}
              <div className="font-sans text-2xl font-bold leading-relaxed text-foreground antialiased">
                {post.excerpt ? post.excerpt.replace(/<[^>]+>/g, "") : "Project performance exceeding industry standards for efficiency and safety."}
              </div>

              {}
              <div className="flex items-center gap-3">
                <div className="h-1 w-12 bg-accent" />
                <span className="font-default text-sm font-bold uppercase tracking-[0.1em] text-primary">
                  {post.title}
                </span>
              </div>
            </div>
          </div>
        </Link>)}
    </div>;
}
export default function QuoteGrid() {
  const wp_query_params = {
    per_page: 6,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}